import { render, staticRenderFns } from "./FavouritesFundListDetails.vue?vue&type=template&id=4c0b1b50&scoped=true"
import script from "./FavouritesFundListDetails.vue?vue&type=script&lang=js"
export * from "./FavouritesFundListDetails.vue?vue&type=script&lang=js"
import style0 from "./FavouritesFundListDetails.vue?vue&type=style&index=0&id=4c0b1b50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0b1b50",
  null
  
)

export default component.exports